import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Grid, InputAdornment } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";

import { useStyles } from "./HomeScreen.style";
import { PageTitle } from "../../components/page-title/PageTitle";
import {
  IoBusinessSharp,
  IoLayersSharp,
  IoSearchOutline,
} from "react-icons/io5";
import { InputField } from "../../components/input-field/InputField";
import { CreateAction } from "./components/CreateAction";
import { BusinessItem } from "./components/BusinessItem";
import { Header } from "./components/Header";
import { BranchItem } from "./components/BranchItem";
import { useAuthenticationContext } from "../../context/UserContext";
import { VerifyingWrapper } from "./components/VerifyingWrapper";
import { AccountRejectedWrapper } from "./components/AccountRejectedWrapper";
import { MoreInformationWrapper } from "./components/MoreInformationWrapper";

export const HomeScreen = (props: any) => {
  const classes = useStyles(props);
  const intl = useIntl();
  // State
  const [tab, setTab] = useState(1);
  const [filter, setFilter] = useState("");
  // Context
  const [user] = useAuthenticationContext();

  const filterChange = (e: any) => {
    setFilter(e.target.value);
  };

  const changeTab = (e: any, tab: number) => {
    e.preventDefault();
    setTab(tab);
  };

  const AccountRejectedOrMoreInfo = () => {
    if (user.isDeclined()) {
      return <AccountRejectedWrapper />;
    }

    if (user.isPending()) {
      return <MoreInformationWrapper />;
    }

    if (user.isApproved()) {
      return null;
    } else {
      return <VerifyingWrapper />;
    }
  };
  return (
    <>
      <PageTitle
        withAppTitle={false}
        title={`${intl.formatMessage({
          id: "sharedScreen.overview",
        })} - ${user.fullName()}`}
      />
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <Header />
          <Grid container className={classes.subHeader}>
            <Grid item sm={1} />
            <Grid item sm={10} xs={12}>
              <Grid container>
                <Grid item sm={6} xs={12} className="subHeaderLeft">
                  <Box className="mainTitle">
                    <FormattedMessage id="sharedScreen.overview" />
                  </Box>
                  <Box className="subTitle">{user.fullName()}</Box>
                </Grid>

                <Grid item sm={6} xs={12} className={classes.actionWrapper}>
                  <Box display="flex" alignItems="center" flexWrap="nowrap">
                    <InputField
                      fullWidth
                      label=""
                      placeholder={intl.formatMessage({
                        id: "sharedScreen.typeToFilter",
                      })}
                      type="text"
                      value={filter}
                      endAdornment={
                        <InputAdornment position="end">
                          <IoSearchOutline />
                        </InputAdornment>
                      }
                      onChange={filterChange}
                    />
                    <Box className={classes.action}>
                      <CreateAction />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={1} />
          </Grid>
          <Grid container className={classes.tabsWrapper}>
            <Grid item sm={1} />
            <Grid item sm={10} xs={12}>
              <ul className={classes.tabs}>
                <li className={classes.tabItem}>
                  <Link
                    to=""
                    className={`${tab === 1 ? "active" : ""}`}
                    onClick={(e) => changeTab(e, 1)}
                  >
                    <span className="icon">
                      <IoBusinessSharp />
                    </span>
                    <FormattedMessage id="sharedScreen.businesses" />
                  </Link>
                  <Link
                    to=""
                    className={`${tab === 2 ? "active" : ""}`}
                    onClick={(e) => changeTab(e, 2)}
                  >
                    <span className="icon">
                      <IoLayersSharp />
                    </span>
                    <FormattedMessage id="sharedScreen.managedBranches" />
                  </Link>
                </li>
              </ul>
            </Grid>
            <Grid item sm={1} />
          </Grid>
          <Grid container className={classes.tabContent}>
            <Grid item sm={1} />
            <Grid item sm={10} xs={12}>
              {tab === 1 ? (
                <div className={classes.slideWrapper}>
                  <BusinessItem />
                </div>
              ) : null}

              {tab === 2 ? (
                <div className={classes.slideWrapper}>
                  <BranchItem />
                </div>
              ) : null}
            </Grid>
            <Grid item sm={1} />
          </Grid>
        </div>
      </div>
      {AccountRejectedOrMoreInfo()}
    </>
  );
};

HomeScreen.routeName = "/";
